import React from 'react';
import { Settings2, FileCode, GitBranch } from 'lucide-react';

const ProgramZWizard = ({ data, setData }) => {
  
  const handleIncludeChange = (index, value) => {
    const newIncludes = [...data.progIncludes];
    newIncludes[index] = value;
    setData({ ...data, progIncludes: newIncludes });
  };

  const handleEventToggle = (event) => {
    setData({
      ...data,
      progEvents: { ...data.progEvents, [event]: !data.progEvents[event] }
    });
  };

  return (
    <div className="animate-in fade-in slide-in-from-top-4 duration-500 text-left">
      
      {/* NOTA DE USO PROFESIONAL */}
      <div className="bg-blue-900/10 border-l-4 border-blue-600 p-4 mb-8 rounded-r-xl">
        <p className="text-[11px] text-blue-700 font-black uppercase tracking-widest mb-1 italic">Nota del Arquitecto:</p>
        <p className="text-[11px] text-slate-600 font-white uppercase leading-relaxed font-medium">
          Defina la arquitectura base de su objeto **Z**. El sistema generará el bloque de comentarios de control (Header), 
          la declaración de Includes y la estructura modular mediante subrutinas. Use el área de texto inferior para describir 
          la lógica funcional que debe contener el programa.
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-10">
        
        {/* COLUMNA 1: METADATOS Y HEADER */}
        <div className="bg-[#0F172A] p-8 rounded-[32px] text-white shadow-xl italic border-b-4 border-blue-500">
          <label className="text-[10px] font-black text-slate-400 uppercase block mb-6 border-b pb-2 flex items-center gap-2">
            <FileCode size={14}/> Metadata & Header Control
          </label>
          <div className="grid grid-cols-2 gap-4">
            <div className="col-span-2">
              <label className="text-[9px] font-bold text-slate-400 uppercase">Nombre del Objeto (Z...)</label>
              <input type="text" className="w-full p-2 bg-slate-50 border rounded-lg text-xs font-mono uppercase" 
                value={data.progName} onChange={e => setData({...data, progName: e.target.value})} />
            </div>
            <div>
              <label className="text-[9px] font-bold text-slate-400 uppercase">Autor</label>
              <input type="text" className="w-full p-2 bg-slate-50 border rounded-lg text-xs" 
                value={data.progAuthor} onChange={e => setData({...data, progAuthor: e.target.value})} />
            </div>
            <div>
              <label className="text-[9px] font-bold text-slate-400 uppercase">Orden de Transporte</label>
              <input type="text" className="w-full p-2 bg-slate-50 border rounded-lg text-xs font-mono uppercase" 
                value={data.progOT} onChange={e => setData({...data, progOT: e.target.value})} />
            </div>
            <div className="col-span-2">
              <label className="text-[9px] font-bold text-slate-400 uppercase">Descripción Funcional</label>
              <input type="text" className="w-full p-2 bg-slate-50 border rounded-lg text-xs" 
                value={data.progDesc} onChange={e => setData({...data, progDesc: e.target.value})} />
            </div>
          </div>
        </div>

        {/* COLUMNA 2: ARQUITECTURA MODULAR */}
        <div className="bg-[#0F172A] p-8 rounded-[32px] text-white shadow-xl italic border-b-4 border-blue-500">
          <label className="text-[10px] font-black text-slate-400 uppercase block mb-6 border-b pb-2 flex items-center gap-2">
            <Settings2 size={14}/> Architecture Components
          </label>
          
          <div className="mb-6">
            <label className="text-[9px] font-bold text-slate-500 uppercase block mb-2">Standard Includes</label>
            <div className="space-y-2">
              {data.progIncludes.map((inc, i) => (
                <input key={i} className="w-full p-2 bg-slate-800 border-none rounded-lg text-[10px] font-mono uppercase focus:ring-1 focus:ring-blue-500 outline-none" 
                  value={inc} onChange={e => handleIncludeChange(i, e.target.value)} />
              ))}
            </div>
          </div>

          <div>
            <label className="text-[9px] font-bold text-slate-500 uppercase block mb-3">Runtime Events</label>
            <div className="grid grid-cols-2 gap-3">
              <label className="flex items-center gap-2 text-[9px] font-bold cursor-pointer">
                <input type="checkbox" checked={data.progEvents.init} onChange={() => handleEventToggle('init')} /> INITIALIZATION
              </label>
              <label className="flex items-center gap-2 text-[9px] font-bold cursor-pointer">
                <input type="checkbox" checked={data.progEvents.start} onChange={() => handleEventToggle('start')} /> START-OF-SELECTION
              </label>
              <label className="flex items-center gap-2 text-[9px] font-bold cursor-pointer">
                <input type="checkbox" checked={data.progEvents.atSel} onChange={() => handleEventToggle('atSel')} /> AT SELECTION-SCREEN
              </label>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default ProgramZWizard;